/**
 * The persisted cache key used by the combined search config cache.
 *
 * This is the single source of truth for the cache name. It is used by:
 * - search-client's promiseCache (scope control for the adapter system)
 * - Host apps (e.g., Confluence StorageManager) to register the key for SSR persistence
 */
export const SEARCH_COMBINED_CONFIG_CACHE_KEY = 'search-combined-config';

/**
 * The localStorage key used by the **bare** (client-only, non-account-namespaced)
 * combined search config runtime cache written by `useRovoConfig` on the FG-on
 * (`rovo_fps_use_rovo_config`) path.
 *
 * Distinct from {@link SEARCH_COMBINED_CONFIG_CACHE_KEY}: that key is routed
 * through the host StorageManager adapter and ends up account-namespaced
 * (`atlassian.<accountId>.frontend.search-combined-config`) and SSR-persisted.
 * This bare key is written directly to localStorage (via BSC/raw) and is NOT
 * account-namespaced and NOT mirrored to the server for SSR.
 */
export const SEARCH_COMBINED_CONFIG_BARE_CACHE_KEY = 'frontend.search-combined-config';
